import React from "react";

export default function Footer({ t }) {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A0F1C] text-white/80 pt-16 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div
            className="text-[22px] font-bold tracking-tight text-white"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Fasade Akershus
          </div>
          <p
            className="mt-4 text-[14px] leading-relaxed max-w-sm text-white/60"
            style={{ fontFamily: "'Manrope', sans-serif" }}
          >
            {t.footer.tagline}
          </p>
        </div>
        <div className="md:col-span-3" style={{ fontFamily: "'Manrope', sans-serif" }}>
          <div className="text-[11px] tracking-[0.22em] uppercase text-white/50 mb-4">
            {t.contact.info.phone_label}
          </div>
          <a
            href="tel:+4746393022"
            data-testid="footer-phone"
            className="block text-[16px] hover:text-white transition-colors"
          >
            46 393 022
          </a>
        </div>
        <div className="md:col-span-4" style={{ fontFamily: "'Manrope', sans-serif" }}>
          <div className="text-[11px] tracking-[0.22em] uppercase text-white/50 mb-4">
            {t.contact.info.email_label}
          </div>
          <a
            href="mailto:kontakt@fasadeakershus.no"
            data-testid="footer-email"
            className="block text-[16px] hover:text-white transition-colors break-all"
          >
            kontakt@fasadeakershus.no
          </a>
        </div>
      </div>
      <div
        className="max-w-7xl mx-auto px-6 md:px-12 mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row gap-3 justify-between text-[12px] text-white/40"
        style={{ fontFamily: "'Manrope', sans-serif" }}
      >
        <div>© {year} Fasade Akershus. {t.footer.rights}</div>
        <div>Akershus · Oslo</div>
      </div>
    </footer>
  );
}
